__turbopack_context__.v({
  "award": "awards-module-scss-module__3Zhhmq__award",
  "awardLogo": "awards-module-scss-module__3Zhhmq__awardLogo",
  "awardText": "awards-module-scss-module__3Zhhmq__awardText",
  "awards": "awards-module-scss-module__3Zhhmq__awards",
  "container": "awards-module-scss-module__3Zhhmq__container",
  "sectionDescription": "awards-module-scss-module__3Zhhmq__sectionDescription",
  "sectionTitle": "awards-module-scss-module__3Zhhmq__sectionTitle",
});
